import React from 'react';
import { connect } from 'react-redux';
import styles from './contacts.module.scss';
import { Helmet } from 'react-helmet';
import mail from '../../assets/mail.png';
import phone from '../../assets/phone.png'

const Contacts = ({showHelmet = true, words}) => {
    const contacts = [
        { icon: mail, label: 'Email', value: 'arman.gharibyan1993@gmail.com', href: 'mailto:arman.gharibyan1993@gmail.com' },
        { icon: phone, label: 'Phone', value: '(+34) 633-54-12-69', href: 'tel:+34633541269' }
    ];

    const profiles = [
        { label: 'LinkedIn', href: 'https://es.linkedin.com/in/armangharibyan' },
        { label: 'GitHub', href: 'https://github.com/ArmanGharibyan93' },
        { label: 'Instagram', href: 'https://www.instagram.com/_arman_gharibyan_/' }
    ];

    return(
        <>
                            {showHelmet && <Helmet>
                <meta 
                    name="keywords" 
                    content="contacts, mobile, mail, email"
                />
                <meta
                    name="description"
                    content="Contacts of Arman Gharibyan"
                />
                <title>{words.contactsTitle}</title>
            </Helmet>}
            <section className={styles.container}>
                <div className={styles.header}>
                    <div className={styles.kicker}>{words.contacts}</div>
                    <h2 className={styles.title}>{words.contactsTitle}</h2>
                </div>
                <div className={styles.grid}>
                    <div className={styles.card}>
                        {contacts.map((item) => (
                            <a key={item.label} className={styles.item} href={item.href}>
                                <img className={styles.icon} src={item.icon} alt={item.label} />
                                <div>
                                    <div className={styles.contactLabel}>{item.label}</div>
                                    <div className={styles.contact}>{item.value}</div>
                                </div>
                            </a>
                        ))}
                    </div>
                    <div className={styles.card}>
                        <div className={styles.cardTitle}>Profiles</div>
                        <div className={styles.profileList}>
                            {profiles.map((item) => (
                                <a key={item.label} className={styles.profileLink} href={item.href} target="_blank" rel="noopener noreferrer">{item.label}</a>
                            ))}
                        </div>
                    </div>
                </div>
            </section>
        </>
        
    )
}

const mapStateToProps = (state) => {
    return{
        words: state.main.words
    }
}

export default connect(mapStateToProps, {})(Contacts)